import ShipperOrdersCell from './component';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['shipper_orders'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { shipper_orders: shipperOrders } = props.selectors.getJourneyFields(
      state,
      props.journeyId,
      fields
    );
    return {
      shipperOrders: (shipperOrders || []).map(({ id }) => id),
    };
  }),
  withHandlers(() => ({
    handleRemoveClick:
      ({ onRemoveShipperOrderClick }) =>
      (shipperOrderId) => {
        onRemoveShipperOrderClick(shipperOrderId);
      },
  }))
);

export default enhance(ShipperOrdersCell);
